import layerFactory from './layer-factory';

export default layerFactory;
